<template>
  <div>
    <b-table
      :data="records"
      :loading="loading"
      :current-page="meta.page"
      :total="meta.record_count"
      :per-page="50"
      :striped="true"
      :narrowed="true"
      paginated
      backend-pagination
      backend-sorting
      @sort="onSort"
      @page-change="onPageChange">

      <template slot-scope="props" slot="header">
        <b-tooltip v-if="props.column.meta" :active="!!props.column.meta" :label="props.column.meta" dashed>
          {{ props.column.label }}
        </b-tooltip>
        <template v-else>
          {{ props.column.label }}
        </template>
      </template>

      <template slot-scope="props">

        <b-table-column field="reference" label="Release Number" sortable>
          <h6 class="title is-6 is-whitespacenowrap" data-attribute="reference">
            <router-link :to="{ name: routeName, params: { id: props.row.id }}">{{ props.row.reference }}</router-link>
          </h6>
          <!-- <h6 v-if="props.row.notes" data-attribute="notes" class="subtitle is-size-7 has-text-grey">{{ props.row.notes }}</h6> -->
        </b-table-column>

        <b-table-column field="status" label="Status" sortable>
          <order-status :record="props.row" />
        </b-table-column>

        <b-table-column field="depot_id" label="Depot">
          <span v-if="props.row.depot" class="tag" data-attribute="depot.name">{{ props.row.depot.name }}</span>
          <span v-else>N/A</span>
        </b-table-column>

        <b-table-column field="color" label="Color" sortable>
          <div v-if="props.row.color" class="color-swatch-wrapper">
            <span class="color-swatch" :class="props.row.color | colorClassName"></span>
            <span data-attribute="color">{{ props.row.color }}</span>
          </div>
        </b-table-column>

        <b-table-column field="product_code" label="Code" meta="Product Code">
          <p>{{ props.row.product ? props.row.product.code : '' }}</p>
        </b-table-column>

        <b-table-column field="created_at" label="Created" width="100" sortable>
          <p class="is-whitespacenowrap" data-attribute="created-at">
            {{ props.row.created_at | formattedDate }}
          </p>
        </b-table-column>

        <b-table-column field="expected_at" label="Expected" width="100" sortable>
          <p class="is-whitespacenowrap" data-attribute="expected-at">
            {{ props.row.expected_at | formattedDate }}
          </p>
        </b-table-column>

        <b-table-column field="unit_count" label="Tot" meta="Total" sortable>
          <span class="count" data-attribute="total-count">{{ props.row.unit_count }}</span>
        </b-table-column>

        <b-table-column field="counts_assigned" label="Asgn" meta="Assigned">
          <!-- TODO <a @click="isOrderUnitsModalActive = true"></a> -->
          <span class="count" data-attribute="assigned-count">{{ props.row.order_units.length }}</span>
        </b-table-column>

        <b-table-column field="counts_delivered" label="Rel" meta="Released">
          <span class="count" data-attribute="released-count">{{ releasedCount(props.row) }}</span>
        </b-table-column>

        <b-table-column field="counts_remaining" label="Rem" meta="Remaining">
          <span class="count" data-attribute="remaining-count">{{ remainingCount(props.row) }}</span>
        </b-table-column>

      </template>
    </b-table>
  </div>
</template>

<script>
  import asyncTable from '../../mixins/async-table'
  import OrderStatus from './status'
  import api from 'shared/json-api'
  export default {
    mixins: [ asyncTable ],
    components: {
      OrderStatus
    },
    props: {
      routeName: {
        type: String,
        default: 'outgoing-order'
      }
    },
    data () {
      return {
        defaultFilter: {
          order_type: 'outgoing'
        }
      }
    },
    methods: {
      releasedCount (record) {
        return record.order_units.filter(i => i.released_at).length
      },
      remainingCount (record) {
        return parseInt(record.unit_count) - this.releasedCount(record)
      },
      loadAsyncData () {
        this.loading = true
        api.findAll('order', {
          sort: this.sortParam,
          include: 'depot,product,order_units',
          page: {
            number: this.meta.page
          },
          filter: this.applyRouteFilter()
        }).then(response => {
          this.handleResponse(response)
        }).catch(() => {
          this.loading = false
        })
      }
    }
  }
</script>
